import {
  Box,
  Divider,
  FormControl,
  FormLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { InputWrapper, LabelStyle } from "../../../Common/styles/form";
import { CheckSuccessIcon } from "./ClosureIcons";
import { closureChecksList } from "../../../../utils/settings";

const phases = [
  "Pre-closure Checks",
  "Study Locking Checks",
  "Post Study Closure Checks",
];

const ClosureConfirmation = ({ inputValue, setInputValue }: any) => {
  return (
    <>
      <Divider sx={{ mb: 3 }} />
      <Stack gap={2}>
        {phases.map((item: any, index: number) => {
          return (
            <Box key={item}>
              <Typography variant="body1" fontWeight="medium" mb={1}>
                Phase {index + 1}: {item}
              </Typography>
              <Stack gap={2}>
                {closureChecksList[index]?.checks?.map((item: any) => {
                  return (
                    <Box
                      key={item.key}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Box
                        sx={{
                          width: 24,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <CheckSuccessIcon />
                      </Box>
                      <Typography variant="subtitle1" fontWeight="regular">
                        {item.label}
                      </Typography>
                    </Box>
                  );
                })}
              </Stack>
              <Divider sx={{ mt: 2 }} />
            </Box>
          );
        })}
      </Stack>
      <Box sx={{ mt: 3, mb: 5 }}>
        <Typography variant="body1" fontWeight="medium" mb={2}>
          Are you sure you want to close this study? This action is permanent,
          and you will not be able to make any changes or restore the study once
          closed. To confirm, please type the study name.
        </Typography>
        <FormControl sx={InputWrapper}>
          <FormLabel sx={LabelStyle} required htmlFor="study-name">
            Study name
          </FormLabel>
          <TextField
            id="study-name"
            placeholder="Study name"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </FormControl>
      </Box>
    </>
  );
};

export default ClosureConfirmation;
